import React from 'react'
import { Icon } from '@chakra-ui/icons'
import { Box, Center, Text } from '@chakra-ui/react'
import { IconType } from 'react-icons/lib/iconBase'

interface Props {
    isActive: boolean
    icon: IconType
    badgeCount: number | undefined
    showIndicator?: boolean
}

export default function SidebarItemIcon({
    isActive,
    icon,
    badgeCount,
    showIndicator,
}: Props) {
    return (
        <Center
            w="32px"
            h="32px"
            minW="32px"
            maxW="32px"
            minH="32px"
            maxH="32px"
            position="relative"
        >
            <Box
                opacity={isActive ? 1 : 0}
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                sx={{
                    backgroundImage:
                        'radial-gradient(rgba(19, 216, 121, 0.05) 0%, rgba(19, 216, 121, 0.3) 20%, rgba(19, 216, 121, 0.05) 40%, rgba(19, 216, 121, 0) 60%)',
                }}
            />
            <Icon
                as={icon}
                fontSize="15px"
                position="relative"
                color={isActive ? 'brand.500' : 'gray.400'}
                transition="0.2s"
            />
            {!!badgeCount && (
                <Center
                    position="absolute"
                    bottom="8px"
                    right="8px"
                    bg="brand.500"
                    rounded="full"
                    w="7px"
                    h="7px"
                    borderWidth="1px"
                    borderColor="brand.300"
                    transition="opacity 0.2s ease-in-out"
                    opacity={showIndicator ? 1 : 0}
                    _groupHover={{
                        opacity: 0,
                    }}
                ></Center>
            )}
        </Center>
    )
}
